module.exports = __webpack_public_path__ + "img/22.5c26de1f.jpg";